"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _getCurrentLanguage = _interopRequireDefault(require("../getCurrentLanguage"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
/**
 * Gets the route prefixed with the current locale
 * @param {string} path
 */
function getLocaleRoute(path) {
  var language = (0, _getCurrentLanguage["default"])();
  var localeRegex = /^(\/|\.)*(en|ar)(\/|\.)*/;
  var sanitizedPath = path;
  // eslint-disable-next-line no-loops/no-loops
  while (localeRegex.test(sanitizedPath)) {
    sanitizedPath = sanitizedPath.replace(localeRegex, '');
  }
  var normalizedPath = sanitizedPath.replace(/^\//, '').replace(/\/$/, '');
  return "/".concat(language).concat(normalizedPath ? "/".concat(normalizedPath) : '');
}
var _default = exports["default"] = getLocaleRoute;